import './sideinfo.less'

import m from 'mithril'
import {classes, Component} from '@codeurs/front'
import EventImage from '../events/eventimage'

export default class SideInfo extends Component<{
	title?: string
	mod?: string
	start_date?: string
}> {
	view() {
		const {mod, title, start_date} = this.attrs
		return m('.sideinfo', classes({mod}), [
			start_date && m(EventImage, {start_date, class: 'sideinfo-eventimage'}),
			title && m('.sideinfo-title', title),
			m('.sideinfo-content', this.children)
		])
	}
}
